import React from 'react';

import {ButtonMover} from '../../button-mover/button-mover';
import {Button} from '../../button/button';

import styles from './add-another-button.module.css';

type Props = {
    text: string;
    onClick: () => void;
};

export function AddAnotherButton(props: Props) {
    return (
        <div className={styles['button-container']}>
            <ButtonMover direction='left' size='normal'>
                {/* @ts-expect-error */}
                <Button variant='text-primary' size='normal' onClick={props.onClick}>
                    {props.text}
                </Button>
            </ButtonMover>
        </div>
    );
}
